import {
  isUserLoggedIn,
  selectExhibitionSettingsIsReadOnlyBuyerAndAccountInfo,
  selectIsNF525Enabled,
  selectIsSIAEEnabled
} from '@app/app.reducer';
import { createSelector } from '@ngrx/store';

export const selectIsReadOnlyBuyerFormFields = createSelector(
  isUserLoggedIn,
  selectExhibitionSettingsIsReadOnlyBuyerAndAccountInfo,
  selectIsSIAEEnabled,
  selectIsNF525Enabled,
  (isUserLoggedIn, isReadOnlyBuyerAndAccountInfo, isSIAEEnabled, isNF525Enabled) =>
    isUserLoggedIn && (isReadOnlyBuyerAndAccountInfo || isSIAEEnabled || isNF525Enabled)
);
